import { fetchDocumentRequests } from '@/api/document-requests.api';
import type { IGetDocumentRequestsParams } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { type MaybeRef, computed, unref } from 'vue';

export const useDocumentRequests = (paramsOrRef?: MaybeRef<IGetDocumentRequestsParams>) => {
    const params = computed(() => unref(paramsOrRef));

    return useQuery(['document-requests', params], () => fetchDocumentRequests(params.value), {
        initialData: {
            count: 0,
            documentRequests: [],
        },
    });
};
